import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69c7aebac3f84800135b6f2a/cognidash/src/app/eeg-cognitive-dashboard/page.tsx");
